(() => {
  const prefillProductRequest = () => {
    if (!document.body.classList.contains('page-contact') && !document.body.classList.contains('page-contact-us')) return;

    const productHandle = new URLSearchParams(window.location.search).get('product');
    const message = document.querySelector('#ContactForm-body');
    if (!productHandle || !message || message.value.trim()) return;

    const safeHandle = productHandle.replace(/[^a-z0-9-]/gi, '');
    if (!safeHandle) return;

    const rootUrl = document.body.dataset.darchiRootUrl || '/';
    const productPath = `${rootUrl.replace(/\/?$/, '/') }products/${safeHandle}`;
    message.value = `Product request: ${new URL(productPath, window.location.origin).href}\n\n`;
    message.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const pinInboxActivatorToBottom = () => {
    const applyPosition = () => {
      document.querySelectorAll('inbox-online-store-chat').forEach((chat) => {
        if (chat.getAttribute('button-vertical-position') !== 'lowest') {
          chat.setAttribute('button-vertical-position', 'lowest');
        }
      });
    };

    applyPosition();

    const observer = new MutationObserver(applyPosition);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.setTimeout(() => {
      applyPosition();
      observer.disconnect();
    }, 30000);
  };

  const initialize = () => {
    prefillProductRequest();
    pinInboxActivatorToBottom();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
